import bg1 from '../../assets/img/hero-img_01.jpg';
import bg2 from '../../assets/img/hero-img_02.jpg';
import bg3 from '../../assets/img/hero-img_03.jpg';
import bg4 from '../../assets/img/hero-img_04.jpg';
import bg5 from '../../assets/img/hero-img_05.jpg';

export const bgArray = [
  {
    id: 'bgImage1',
    url: bg1,
  },
  {
    id: 'bgImage2',
    url: bg2,
  },
  {
    id: 'bgImage3',
    url: bg3,
  },
  {
    id: 'bgImage4',
    url: bg4
  },
  {
    id: 'bgImage5',
    url: bg5,
  }
];
